import _ from 'lodash'
import moment from 'moment'
import timelineToGraphData from '../../../services/timeline/timeline'

/** @ngInject */
function subscriptionTimelineCtrl(DeviceChecker, ContractDraft, ErrorCatcher) {
    const ctrl = this
    ctrl.isMobile = DeviceChecker.isMobile
    ctrl.view = {
        name: 'timetable',
        isLoadingTimetable: false,
        timeline: [],
        error: false,
        errorMessage: undefined,
    }

    ctrl.update = () => ctrl.onUpdate()

    ctrl.updateContractDraft = () => ctrl.onContractDraftUpdate({ value: ctrl.form })

    ctrl.$onChanges = function (changes) {
        const isActive = _.get(changes, 'isActive.currentValue', false) || false
        if (ctrl.contractDraft.nextBillableDate) {
            ctrl.view.nextBillableDate = moment(ctrl.contractDraft.nextBillableDate).add(15, 'day').format('MMMM YYYY').toLowerCase()
        }
        if (isActive) {
            ctrl.view.timeline = []
            ctrl.view.isLoadingTimetable = true
            ctrl.view.error = false
            ctrl.view.errorMessage = undefined
            const fnGetTimetable = (ctrl.contractDraft.estimated_v !== 0) ? 'getTimetableV2' : 'getTimetableV1'

            ContractDraft[fnGetTimetable]().$promise
            .then((values) => {
                if (_.isEmpty(values)) {
                    // Continue to next step as there isn't any data to display
                    ctrl.update()
                    ErrorCatcher.catchError({
                        message: 'no timeline data was found for current contract draft',
                        contractDraft: ctrl.contractDraft.id,
                    })
                } else {
                    ctrl.view.timeline = timelineToGraphData(values)
                    ctrl.view.isLoadingTimetable = false
                }
            }).catch((error) => {
                ErrorCatcher.catchError(error)
                ctrl.view.error = true
                ctrl.view.errorMessage = error.data.message
                ctrl.view.isLoadingTimetable = false
            })
        }
    }
}

export default {
    restrict: 'E',
    bindings: {
        contractDraft: '<',
        isActive: '<',
        isUpdating: '<',
        onUpdate: '&',
        onContractDraftUpdate: '&',
    },
    template: require('./subscriptionTimeline.jade')(),
    controller: subscriptionTimelineCtrl,
}



// WEBPACK FOOTER //
// ./src/states/subscription/component/subscriptionTimeline.js